module.exports = __webpack_public_path__ + "static/media/img_cal9.8f79ecad.jpg";